export const INIT_NEW_CART = 'order/init-new-order';
export const ADD_ITEM_TO_CART = 'order/add-to-cart';
export const REMOVE_ITEM_FROM_CART = 'order/remove-from-cart';
export const PATCH_ITEM_CART = 'order/patch-item-cart';
